'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherCheck, FeatherLoader, FeatherX } from '@subframe/core';
import type { ReactNode } from 'react';
import { Checkbox, TextField } from '@/shared/components/ui';
import type { UseNotificacaoSelfReturn } from '../hooks';
import type { CnpjStatus } from '../types';
import { AvisoFunil } from './AvisoFunil';
import { WizardFooter } from './WizardFooter';
import { WizardHeader } from './WizardHeader';
interface CadastroScreenProps {
  vm: UseNotificacaoSelfReturn;
}
const CNPJ_STATUS_ERRO: CnpjStatus[] = ['invalido', 'jaCadastrada'];
const MENSAGEM_CNPJ: Partial<Record<CnpjStatus, string>> = {
  invalido: 'CNPJ inválido. Confira os números e tente novamente.',
  naoEncontrado: 'CNPJ não encontrado na Receita. Preencha os dados da empresa manualmente.',
  jaCadastrada: 'Empresa já cadastrada na plataforma Arbitralis.'
};
export const CadastroScreen = t0 => {
  const $ = _c(108);
  const {
    vm
  } = t0;
  const {
    form,
    cnpjStatus,
    sessaoExpirada,
    cadastroErro,
    planosErro
  } = vm;
  let t1;
  if ($[0] !== cnpjStatus) {
    t1 = CNPJ_STATUS_ERRO.includes(cnpjStatus);
    $[0] = cnpjStatus;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cnpjTemErro = t1;
  let t2;
  if ($[2] !== cnpjStatus || $[3] !== cnpjTemErro) {
    t2 = cnpjStatus === "consultando" ? <FeatherLoader className="animate-spin text-neutral-500" /> : cnpjStatus === "ok" ? <FeatherCheck className="text-success-700" /> : cnpjTemErro ? <FeatherX className="text-error-600" /> : null;
    $[2] = cnpjStatus;
    $[3] = cnpjTemErro;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const iconeCnpj = t2;
  const mensagemCnpj = cnpjTemErro && vm.cnpjErro ? vm.cnpjErro : MENSAGEM_CNPJ[cnpjStatus];
  let t3;
  if ($[5] !== sessaoExpirada) {
    t3 = sessaoExpirada && <AvisoFunil variante="aviso">Sua sessão do cadastro expirou, recomece.</AvisoFunil>;
    $[5] = sessaoExpirada;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== cadastroErro) {
    t4 = cadastroErro && <AvisoFunil variante="erro">{cadastroErro}</AvisoFunil>;
    $[7] = cadastroErro;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== planosErro || $[10] !== vm.recarregarPlanos) {
    t5 = planosErro && <AvisoFunil variante="erro"><span className="flex-1">{planosErro}</span><button type="button" onClick={vm.recarregarPlanos} className="flex-none text-sm font-semibold underline">Tentar novamente</button></AvisoFunil>;
    $[9] = planosErro;
    $[10] = vm.recarregarPlanos;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <>{t3}{t4}{t5}</>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const avisos = t6;
  let t7;
  if ($[16] !== vm.stepperSteps) {
    t7 = <WizardHeader steps={vm.stepperSteps} />;
    $[16] = vm.stepperSteps;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="flex flex-col gap-3"><h1 className="text-heading-dark text-2xl font-semibold sm:text-[30px]">Quem é você e qual é a sua empresa?</h1><p className="text-label-muted max-w-[420px] text-base leading-relaxed">Essas informações confirmam sua empresa e garantem que só pessoas autorizadas enviem notificações em nome dela.</p></div>;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== vm) {
    t9 = event => vm.atualizarCampo("cnpj", event.target.value);
    $[19] = vm;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== form.cnpj || $[22] !== t9) {
    t10 = <TextField.Input placeholder="00.000.000/0001-00" value={form.cnpj} onChange={t9} />;
    $[21] = form.cnpj;
    $[22] = t9;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== cnpjTemErro || $[25] !== iconeCnpj || $[26] !== t10) {
    t11 = <TextField className="w-full" label="CNPJ *" error={cnpjTemErro} iconRight={iconeCnpj}>{t10}</TextField>;
    $[24] = cnpjTemErro;
    $[25] = iconeCnpj;
    $[26] = t10;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== cnpjStatus || $[29] !== cnpjTemErro || $[30] !== mensagemCnpj) {
    t12 = mensagemCnpj && <div className="flex items-center justify-between gap-3"><span className={`text-xs ${cnpjTemErro ? "text-error-700" : "text-warning-800"}`}>{mensagemCnpj}</span>{cnpjStatus === "jaCadastrada" && <a href="/login" className="text-brand-600 flex-none text-xs font-semibold whitespace-nowrap">Acessar minha conta →</a>}</div>;
    $[28] = cnpjStatus;
    $[29] = cnpjTemErro;
    $[30] = mensagemCnpj;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t11 || $[33] !== t12) {
    t13 = <div className="flex flex-col gap-1.5">{t11}{t12}</div>;
    $[32] = t11;
    $[33] = t12;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  const t14 = cnpjStatus === "consultando" ? "Consultando..." : "Ex: Arbitralis S.A.";
  let t15;
  if ($[35] !== vm) {
    t15 = event_0 => vm.atualizarCampo("razaoSocial", event_0.target.value);
    $[35] = vm;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== form.razaoSocial || $[38] !== t14 || $[39] !== t15) {
    t16 = <TextField className="w-full" label={"Raz\xE3o social *"} helpText={"Preenchida automaticamente pelo CNPJ; ajuste se necess\xE1rio"}><TextField.Input placeholder={t14} value={form.razaoSocial} onChange={t15} /></TextField>;
    $[37] = form.razaoSocial;
    $[38] = t14;
    $[39] = t15;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  if ($[41] !== vm) {
    t17 = event_1 => vm.atualizarCampo("nomeFantasia", event_1.target.value);
    $[41] = vm;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== form.nomeFantasia || $[44] !== t17) {
    t18 = <TextField className="w-full" label="Nome fantasia *"><TextField.Input placeholder="Ex: Arbitralis" value={form.nomeFantasia} onChange={t17} /></TextField>;
    $[43] = form.nomeFantasia;
    $[44] = t17;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== t16 || $[47] !== t18) {
    t19 = <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">{t16}{t18}</div>;
    $[46] = t16;
    $[47] = t18;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  const t20 = form.telefone.length > 0 && !vm.telefoneValido;
  const t21 = form.telefone.length > 0 && !vm.telefoneValido ? "Informe um telefone v\xE1lido com DDD." : undefined;
  let t22;
  if ($[49] !== vm) {
    t22 = event_2 => vm.atualizarCampo("telefone", event_2.target.value);
    $[49] = vm;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== form.telefone || $[52] !== t22) {
    t23 = <TextField.Input placeholder="(00) 00000-0000" value={form.telefone} onChange={t22} />;
    $[51] = form.telefone;
    $[52] = t22;
    $[53] = t23;
  } else {
    t23 = $[53];
  }
  let t24;
  if ($[54] !== t20 || $[55] !== t21 || $[56] !== t23) {
    t24 = <TextField className="w-full" label="Telefone principal *" error={t20} helpText={t21}>{t23}</TextField>;
    $[54] = t20;
    $[55] = t21;
    $[56] = t23;
    $[57] = t24;
  } else {
    t24 = $[57];
  }
  let t25;
  if ($[58] !== vm) {
    t25 = event_3 => vm.atualizarCampo("responsavelNome", event_3.target.value);
    $[58] = vm;
    $[59] = t25;
  } else {
    t25 = $[59];
  }
  let t26;
  if ($[60] !== form.responsavelNome || $[61] !== t25) {
    t26 = <TextField className="w-full" label={"Nome completo do respons\xE1vel *"}><TextField.Input placeholder="Ex: Mariana Costa" value={form.responsavelNome} onChange={t25} /></TextField>;
    $[60] = form.responsavelNome;
    $[61] = t25;
    $[62] = t26;
  } else {
    t26 = $[62];
  }
  const t27 = form.responsavelEmail.length > 0 && !vm.emailResponsavelValido;
  const t28 = form.responsavelEmail.length > 0 && !vm.emailResponsavelValido ? "Digite um e-mail v\xE1lido" : undefined;
  let t29;
  if ($[63] !== vm) {
    t29 = event_4 => vm.atualizarCampo("responsavelEmail", event_4.target.value);
    $[63] = vm;
    $[64] = t29;
  } else {
    t29 = $[64];
  }
  let t30;
  if ($[65] !== form.responsavelEmail || $[66] !== t29) {
    t30 = <TextField.Input placeholder="Ex: mariana@empresa.com.br" value={form.responsavelEmail} onChange={t29} />;
    $[65] = form.responsavelEmail;
    $[66] = t29;
    $[67] = t30;
  } else {
    t30 = $[67];
  }
  let t31;
  if ($[68] !== t27 || $[69] !== t28 || $[70] !== t30) {
    t31 = <TextField className="w-full" label={"E-mail do respons\xE1vel *"} error={t27} helpText={t28}>{t30}</TextField>;
    $[68] = t27;
    $[69] = t28;
    $[70] = t30;
    $[71] = t31;
  } else {
    t31 = $[71];
  }
  let t32;
  if ($[72] !== t26 || $[73] !== t31) {
    t32 = <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">{t26}{t31}</div>;
    $[72] = t26;
    $[73] = t31;
    $[74] = t32;
  } else {
    t32 = $[74];
  }
  let t33;
  if ($[75] !== form.termosAceitos || $[76] !== vm.alternarTermos) {
    t33 = <Checkbox checked={form.termosAceitos} onCheckedChange={vm.alternarTermos} label="Li e aceito os Termos de Uso da Arbitralis" />;
    $[75] = form.termosAceitos;
    $[76] = vm.alternarTermos;
    $[77] = t33;
  } else {
    t33 = $[77];
  }
  let t34;
  if ($[78] !== vm) {
    t34 = <button type="button" onClick={() => vm.goTo("termos")} className="text-brand-600 text-[13px] font-semibold underline">Ver termos completos</button>;
    $[78] = vm;
    $[79] = t34;
  } else {
    t34 = $[79];
  }
  let t35;
  if ($[80] !== t33 || $[81] !== t34) {
    t35 = <div className="flex items-center gap-2">{t33}{t34}</div>;
    $[80] = t33;
    $[81] = t34;
    $[82] = t35;
  } else {
    t35 = $[82];
  }
  let t36;
  if ($[83] !== vm.alternarMedicao || $[84] !== vm.medicaoAutorizada) {
    t36 = <Checkbox checked={vm.medicaoAutorizada} onCheckedChange={vm.alternarMedicao} label={"Autorizo compartilhar dados de navega\xE7\xE3o e a confirma\xE7\xE3o da inscri\xE7\xE3o com Google, Meta e OpenAI para medir an\xFAncios (opcional)"} />;
    $[83] = vm.alternarMedicao;
    $[84] = vm.medicaoAutorizada;
    $[85] = t36;
  } else {
    t36 = $[85];
  }
  let t37;
  if ($[86] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <a href="/politica-de-privacidade" target="_blank" rel="noopener noreferrer" className="text-brand-600 text-xs underline">Ver política de privacidade</a>;
    $[86] = t37;
  } else {
    t37 = $[86];
  }
  let t38;
  if ($[87] !== t36) {
    t38 = <div className="flex flex-col gap-1">{t36}{t37}</div>;
    $[87] = t36;
    $[88] = t38;
  } else {
    t38 = $[88];
  }
  let t39;
  if ($[89] !== avisos || $[90] !== t13 || $[91] !== t19 || $[92] !== t24 || $[93] !== t32 || $[94] !== t35 || $[95] !== t38) {
    t39 = <div className="flex flex-1 justify-center px-6 py-10 md:px-20 md:py-14"><div className="grid w-full max-w-[1280px] grid-cols-1 gap-10 lg:grid-cols-[minmax(280px,1fr)_minmax(420px,1.85fr)] lg:gap-20">{t8}<div className="flex w-full flex-col gap-5">{avisos}{t13}{t19}{t24}{t32}{t35}{t38}</div></div></div>;
    $[89] = avisos;
    $[90] = t13;
    $[91] = t19;
    $[92] = t24;
    $[93] = t32;
    $[94] = t35;
    $[95] = t38;
    $[96] = t39;
  } else {
    t39 = $[96];
  }
  let t40;
  if ($[97] !== vm) {
    t40 = () => vm.goTo("inicio");
    $[97] = vm;
    $[98] = t40;
  } else {
    t40 = $[98];
  }
  const t41 = !vm.podeAvancarCadastro;
  let t42;
  if ($[99] !== t40 || $[100] !== t41 || $[101] !== vm.enviandoCadastro || $[102] !== vm.enviarCadastro) {
    t42 = <WizardFooter onCancelar={t40} onConfirmar={vm.enviarCadastro} confirmarDisabled={t41} confirmarLoading={vm.enviandoCadastro} />;
    $[99] = t40;
    $[100] = t41;
    $[101] = vm.enviandoCadastro;
    $[102] = vm.enviarCadastro;
    $[103] = t42;
  } else {
    t42 = $[103];
  }
  let t43;
  if ($[104] !== t39 || $[105] !== t42 || $[106] !== t7) {
    t43 = <div className="flex min-h-screen w-full flex-col bg-white">{t7}{t39}{t42}</div>;
    $[104] = t39;
    $[105] = t42;
    $[106] = t7;
    $[107] = t43;
  } else {
    t43 = $[107];
  }
  return t43;
};